import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Button from '../Button/Button';
import IconArrowHead from '../IconArrowHead/IconArrowHead';
import IconEdit from '../IconEdit/IconEdit';
import IconCollection from '../IconCollection/IconCollection';
import css from './ListingWizardBottomNav.module.css';

const ListingWizardBottomNav = ({
    onBack,
    onSaveDraft,
    onEditListing,
    onPublishNow,
    saveDraftDisabled = false,
    editListingDisabled = false,
    publishNowDisabled = false,
    className,
    EditButtonText = "Listing",
    isPrevNextBtn = false,
}) => {
    return (
        <nav className={classNames(css.root, className)}>
            {isPrevNextBtn ? <div className={css.prevNextBtnWrapperMobile}>
                <Button variant="warning" className={css.prevNextBtn} arrow="left" icon={<IconCollection name="mobile_left_arrow" />} onClick={onBack}>Previous Blog</Button>
                <Button variant="info" disabled={true} className={css.prevNextBtn} arrow="right" icon={<IconCollection name="mobile_right_arrow" />} onClick={onBack}>Next Blog</Button>
            </div> : null}
            <div className={css.container}>
                <div className={css.left}>
                    <Button variant="info" className={css.backBtn} arrow="left" icon={<IconArrowHead direction="left" />} onClick={onBack}>

                        <span className={css.backBtnText}>Back</span>
                    </Button>
                </div>
                <div className={css.right}>
                    <Button
                        variant="secondary-outline"
                        className={css.saveDraftBtn}
                        onClick={onSaveDraft}
                        disabled={saveDraftDisabled}
                        icon={<IconCollection name="description" />}
                        arrow="left"
                    >
                        <span className={css.saveDraftBtnText}>Save</span> Draft
                    </Button>
                    <Button
                        variant="secondary-outline"
                        icon={<IconCollection name="edit_book" />}
                        arrow="left"
                        className={css.editListingBtn}
                        onClick={onEditListing}
                        disabled={editListingDisabled}
                    >

                        Edit <span className={css.editListingBtnText}>{EditButtonText}</span>
                    </Button>
                    <Button
                        variant="primary"
                        className={css.publishNowBtn}
                        onClick={onPublishNow}
                        disabled={publishNowDisabled}
                    >
                        Publish <span className={css.publishNowBtnText}>Now</span>
                    </Button>
                </div>
            </div>
        </nav>
    );
};

ListingWizardBottomNav.propTypes = {
    onBack: PropTypes.func.isRequired,
    onSaveDraft: PropTypes.func.isRequired,
    onEditListing: PropTypes.func.isRequired,
    onPublishNow: PropTypes.func.isRequired,
    saveDraftDisabled: PropTypes.bool,
    editListingDisabled: PropTypes.bool,
    publishNowDisabled: PropTypes.bool,
    className: PropTypes.string,
};

export default ListingWizardBottomNav; 